var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPairCatalog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.215,
    height: 47.251,
    viewBox: "0 0 48.215 47.251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573",
    transform: "translate(-43.893 -373.375)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_261",
    "data-name": "Rectangle 261",
    width: 48.215,
    height: 47.251,
    rx: 13,
    transform: "translate(43.893 373.375)",
    fill: "#80d3b5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ion-ios-git-network",
    "data-name": "Icon ion-ios-git-network",
    d: "M29.16,2.25a5.565,5.565,0,0,0-4.178,9.23,5.5,5.5,0,0,0,3.006,1.77v3.391L19.608,21l-8.372-4.359V13.25a5.559,5.559,0,1,0-5.358-1.77,5.5,5.5,0,0,0,3.006,1.77v4.517a.551.551,0,0,0,.307.5l9.246,4.784V26.5a5.557,5.557,0,1,0,5.351,1.77A5.5,5.5,0,0,0,20.78,26.5V23.046l9.246-4.784a.551.551,0,0,0,.307-.5V13.25a5.563,5.563,0,0,0-1.172-11ZM6.845,7.813a3.21,3.21,0,1,1,3.21,3.21,3.214,3.214,0,0,1-3.21-3.21ZM22.818,31.938a3.21,3.21,0,1,1-3.21-3.21A3.214,3.214,0,0,1,22.818,31.938ZM29.16,11.031a3.21,3.21,0,1,1,3.21-3.21A3.214,3.214,0,0,1,29.16,11.031Z",
    transform: "translate(48.393 378.125)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPairCatalog);
export default __webpack_public_path__ + "static/media/pair_catalog.70a86318d752b08b1f7b94c4ef304ce8.svg";
export { ForwardRef as ReactComponent };